<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <router-link to="/category" class="breadscrumbs-item"
        >Category</router-link
      >
      <v-icon>chevron_right</v-icon>
      <router-link to="/category/category-info" class="breadscrumbs-item active"
        >Category Info</router-link
      >
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>{{ categoryName }}</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <div>編輯</div>
      </button>
      <button class="btn" @click="deleteHandler">
        <v-icon class="mr-2">delete</v-icon>
        <div>刪除</div>
      </button>
    </div>
    <!-- block -->
    <div class="block">
      <!-- Category Name -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category Name</h4>
        <div class="flex-grow-1F">
          {{ categoryName }}
        </div>
      </label>
      <!-- BU -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">BU</h4>
        <div class="flex-grow-1">
          consumer
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="flex-grow-1">
          001-001
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1">
          32
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1">
          顯示
        </div>
      </label>
      <!-- 圖片 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於官網BU Page
          </div>
        </div>
        <div class="flex-grow-1">
          <div
            class="w-240px h-240px bg-cover bg-center"
            :style="{
              'background-image': `url(https://dummyimage.com/240x240.jpg)`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    categoryName: '外接式儲存裝置',
  }),
  methods: {
    editHandler() {
      this.$router.push({ path: '/category/category-info/edit' });
    },
    deleteHandler() {
      this.$router.push({ path: '/category' });
    },
  },
};
</script>

<style lang="scss">
.category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
